export default "__VITE_ASSET__D15bE3qd__"